const LOW_ACTION_LABELS = {
  question_search: "질문하기",
  case_comparison: "내 상황과 비교하기",
  paid_chat_reset: "대화 초기화",
  rehearsal: "맞춤 문장 만들기",
};

const LOW_ACTION_MESSAGES = {
  question_search: "현재 ‘질문하기’를 진행하고 있어요.",
  case_comparison: "현재 ‘내 상황과 비교하기’를 진행하고 있어요.",
  paid_chat_reset: "현재 ‘대화 초기화’를 진행하고 있어요.",
  rehearsal: "현재 ‘맞춤 문장 만들기’를 진행하고 있어요.",
};

export class LowActionConflictError extends Error {
  constructor(conflict) {
    super("low-action-in-progress");
    this.name = "LowActionConflictError";
    this.conflict = conflict;
  }
}

export const getLowActionLabel = (action) =>
  LOW_ACTION_LABELS[action] || "다른 작업";

export const getLowActionConflict = async (response) => {
  if (!response || response.status !== 409) return null;

  let data;
  try {
    data = await response.json();
  } catch (_) {
    return null;
  }
  if (data?.code !== "low_action_in_progress") return null;

  const action = String(data.active_action || "");
  return {
    action,
    label: getLowActionLabel(action),
  };
};

export const getLowActionConflictMessage = (conflict) =>
  LOW_ACTION_MESSAGES[conflict?.action] || "현재 다른 작업을 진행하고 있어요.";
